import * as angular from 'angular';
import { WatsonUsageTrackingService } from './watson-usage-tracking.service';

export const watsonUsageTrackingModule = angular.module('watsonUsageTrackingService', [])
	.service('watsonUsageTrackingService', WatsonUsageTrackingService)
	.name;
